import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import { getViewStateByName } from '../appViewStates';
import {
    CLOSE_NAVIGATION,
    OPEN_NAVIGATION
} from './actions';
import {
    VOID_BULK_SUCCESS,
    VOID_SUCCESS
} from '../Void/voidActions';
import {
    CAPTURE_BULK_SUCCESS,
    CAPTURE_SUCCESS
} from '../Capture/captureActions';
import {
    FRAUD_COUNT_FAILURE,
    FRAUD_COUNT_SUCCESS
} from '../Fraud/fraudActions';
import {
    PENDING_COUNT_FAILURE,
    PENDING_COUNT_SUCCESS
} from '../PayoutBatches/payoutBatchesActions';
import {
    PAYOUT_BATCH_REJECT_SUCCESS,
    PAYOUT_BATCH_APPROVE_SUCCESS
} from '../PayoutBatch/payoutBatchActions';

export default function reducer(state = { isNavigationOpen: false }, action = {}){
    let newState;

    switch (action.type) {
        case VOID_BULK_SUCCESS:
        case VOID_SUCCESS:
        case CAPTURE_BULK_SUCCESS:
        case CAPTURE_SUCCESS:
            newState = {
                ...state,
                shouldReloadFraudCount: true
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_COUNT_FAILURE:
        case FRAUD_COUNT_SUCCESS:
            newState = {
                ...state,
                shouldReloadFraudCount: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_REJECT_SUCCESS:
        case PAYOUT_BATCH_APPROVE_SUCCESS:
            newState = {
                ...state,
                shouldReloadPendingCount: true
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_COUNT_FAILURE:
        case PENDING_COUNT_SUCCESS:
            newState = {
                ...state,
                shouldReloadPendingCount: false
            };

            return isEqual(state, newState) ? state : newState;

        case CLOSE_NAVIGATION:
            newState = {
                ...state,
                isNavigationOpen: false
            };

            return isEqual(state, newState) ? state : newState;

        case OPEN_NAVIGATION:
            newState = {
                ...state,
                isNavigationOpen: true
            };

            return isEqual(state, newState) ? state : newState;

        default:

            return state;
    }
}

export const getNavigationViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'navigation')
);

export const getIsNavigationOpen = createSelector(
    getNavigationViewState,
    (viewState) => get(viewState, 'isNavigationOpen')
);

export const getShouldReloadFraudCount = createSelector(
    (getNavigationViewState),
    (viewState) => get(viewState, 'shouldReloadFraudCount')
);

export const getShouldReloadPendingCount = createSelector(
    (getNavigationViewState),
    (viewState) => get(viewState, 'shouldReloadPendingCount')
);
